import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useLocation } from "react-router-dom"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import Button from "../../shared/Button"
import { PieChart } from "@mui/x-charts"
import { getAverageVehicleSupplyTimeReport } from "../../../features/reports/reportSlice"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1500px;
        height: 700px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
        .content{
            margin-block: 20px;
            padding: 0 30px;
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
            .title-list{
                display:grid;
                grid-template-columns: repeat(12, 1fr);
                width: 100%;
                gap: 20px;
                text-align: center;
                align-items: center;
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                margin-bottom: 20px;
                padding-bottom: 10px;
                border-bottom: 2px solid;
                border-color: ${({ theme }) => theme.mainBorderColor};
                
            }
            .main-side{
                text-align: center;
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 10px;
                .info{
                    display:grid;
                    grid-template-columns: repeat(12, 1fr);
                    gap: 20px;
                    .text{
                        text-align: center;
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                    }
                }
            }
            .total-container{
                display:grid;
                grid-template-columns: repeat(12, 1fr);
                text-align: center;
                gap: 20px;
                width: 100%;
                margin-top: 20px;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                border-top: 2px solid;
                border-color: ${({ theme }) => theme.mainBorderColor};
                padding-top: 10px;
                .total{
                    font-weight: var(--font-weight-lg);
                    font-size: var(--font-size-md);
                }
            }
            .charts{
                width: 100%;
                height: 100%;
                display: flex;
                align-items: flex-end;
                justify-content: center;
                margin-top: 30px;
            }
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin-bottom: 20px;
        }
    }
`

const titles = ["Ay", "Karşılanan Arac Sayısı", "0-3", "3-6", "6-9"," 9-12", "12-15", "15-18", "18-21", "21-24", "24-48", ">48"]


const OrtalamaAracTedarikModal = () => {

    const dispatch = useDispatch()

    const location = useLocation()
    const {ortalamaAracTedarikRapor } = useSelector(state => state.report)
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const companyId = JSON.parse(storage.getItem("companyId"))    
    const [tedarikTotal, setTedarikTotal] = useState(0)

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

       //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    useEffect(() => {
        dispatch(getAverageVehicleSupplyTimeReport(companyId))
    }, [companyId])

    useEffect(() => {
        const toplamTedarik = ortalamaAracTedarikRapor.monthlyVehicleSupplies?.reduce((accumulator, currentItem) => accumulator + currentItem.suppliedVehicleCount, 0);
        setTedarikTotal(toplamTedarik)
    }, [ortalamaAracTedarikRapor])

    const seriesData = [
        {
            data:  [
                { id: 1, value: ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationZeroToThreeHours?.count, label: '0-3', color: "#E85446" },
                { id: 2, value: ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationThreeToSixHours?.count, label: '3-6', color: "#F29E4C" },
                { id: 3, value: ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationSixToNineHours?.count, label: '6-9', color: "#F1C40F" },
                { id: 4, value: ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationNineToTwelveHours?.count, label: '9-12', color: "#2ECC71" },
                { id: 5, value: ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationTwelveToFifteenHours?.count, label: '12-15', color: "#3498DB" },
                { id: 6, value: ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationFifteenToEighteenHours?.count, label: '15-18', color: "#9B59B6" },
                { id: 7, value: ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationEighteenToTwentyOneHours?.count, label: '18-21', color: "#34495E" },
                { id: 8, value: ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationTwentyOneToTwentyFourHours?.count, label: '21-24', color: "#16A085" },
                { id: 9, value: ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationTwentyFourToFortyEightHours?.count, label: '24-48', color: "#27AE60" },
                { id: 10, value: ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationMoreThanFortyEightHours?.count, label: '>48', color: "#8E44AD" },
            ]
        },
    ]


  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
            <PageTopTitle title={"Ortalama Araç Tedarik Süreleri"}/>
            <div className="content">
                
                <div className="title-list">
                    {titles.map((item) => (
                        <div className="title">{item}</div>
                    ))}
                </div>
                <div className="main-side">
                    {ortalamaAracTedarikRapor?.monthlyVehicleSupplies?.map((item) => {
                        return (
                        <div className="info">
                            <div className="text">{item?.month}</div>
                            <div className="text">{item?.suppliedVehicleCount}</div>
                            <div className="text">{item?.vehicleSupplyDuration?.durationZeroToThreeHours?.countWithRate}</div>
                            <div className="text">{item?.vehicleSupplyDuration?.durationThreeToSixHours?.countWithRate}</div>
                            <div className="text">{item?.vehicleSupplyDuration?.durationSixToNineHours?.countWithRate}</div>
                            <div className="text">{item?.vehicleSupplyDuration?.durationNineToTwelveHours?.countWithRate}</div>
                            <div className="text">{item?.vehicleSupplyDuration?.durationTwelveToFifteenHours?.countWithRate}</div>
                            <div className="text">{item?.vehicleSupplyDuration?.durationFifteenToEighteenHours?.countWithRate}</div>
                            <div className="text">{item?.vehicleSupplyDuration?.durationEighteenToTwentyOneHours?.countWithRate}</div>
                            <div className="text">{item?.vehicleSupplyDuration?.durationTwentyOneToTwentyFourHours?.countWithRate}</div>
                            <div className="text">{item?.vehicleSupplyDuration?.durationTwentyFourToFortyEightHours?.countWithRate}</div>
                            <div className="text">{item?.vehicleSupplyDuration?.durationMoreThanFortyEightHours?.countWithRate}</div>
                            
                        </div>
                    )})}
                </div>
                <div className="total-container">
                    <div className="total">Toplam</div>
                    <div className="calc">{tedarikTotal}</div>
                    <div className="calc">{ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationZeroToThreeHours?.countWithRate}</div>
                    <div className="calc">{ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationThreeToSixHours?.countWithRate}</div>
                    <div className="calc">{ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationSixToNineHours?.countWithRate}</div>
                    <div className="calc">{ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationNineToTwelveHours?.countWithRate}</div>
                    <div className="calc">{ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationTwelveToFifteenHours?.countWithRate}</div>
                    <div className="calc">{ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationFifteenToEighteenHours?.countWithRate}</div>
                    <div className="calc">{ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationEighteenToTwentyOneHours?.countWithRate}</div>
                    <div className="calc">{ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationTwentyOneToTwentyFourHours?.countWithRate}</div>
                    <div className="calc">{ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationTwentyFourToFortyEightHours?.countWithRate}</div>
                    <div className="calc">{ortalamaAracTedarikRapor?.totalYearlyVehicleSupplyDuration?.durationMoreThanFortyEightHours?.countWithRate}</div>
                </div>
                <div className="charts">
                    <PieChart
                        series={seriesData}
                        width={850}
                        height={350}
                    />
                </div>
            </div>
            <div className='button-grp'>
                <Button color={"#F4F4F4"} background={"#E85446"} width="310px" radius={"10px"} text={"Geri Dön"} handleClick={()=> dispatch(showModal(null))}/>
            </div>
        </div>
    </ModalContainer>
  )
}

export default OrtalamaAracTedarikModal